// v2.1.1 — LLM-generated 2–3 sentence executive summary above the
// summary bar. Stubbed from _stubData.ts for now.
import type { ReactElement } from "react";
import { SrIcon } from "./SrIcon.tsx";

interface Props {
  summary: string;
}

export function SlipExecutiveSummary({ summary }: Props): ReactElement {
  return (
    <div
      style={{
        background: "var(--bg-elev)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius-lg)",
        padding: "16px 20px",
        marginBottom: 12,
        display: "flex",
        gap: 14,
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: 7,
          background: "var(--accent-soft)",
          color: "var(--accent-text)",
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
        }}
      >
        <SrIcon name="sparkle" size={14} />
      </div>
      <div style={{ flex: 1 }}>
        <div
          style={{
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: "var(--text-tertiary)",
            marginBottom: 6,
          }}
        >
          Executive summary
        </div>
        <div style={{ fontSize: 13.5, lineHeight: 1.55, color: "var(--text-secondary)" }}>{summary}</div>
      </div>
    </div>
  );
}
